module.exports = __webpack_public_path__ + "img/banner3.2a8d43dd.jpg";